import { render, staticRenderFns } from "./DefaultPortfolioButton.vue?vue&type=template&id=36c18d09&"
import script from "./DefaultPortfolioButton.vue?vue&type=script&lang=js&"
export * from "./DefaultPortfolioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports